import React from "react";
import Layout from "../../../../layout/base/Layout";
import Image from "../../../../common/image/Image";
import { Alert, Badge, Col } from "antd";
import { COLORS, SIZES, Typo } from "../../../../layout/theme";
import { AuditOutlined, PhoneOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CartIcon from "../../../../../assets/images/cart-shopping-solid.svg";
import MenuIcon from "../../../../../assets/images/bars-solid-2.svg";
import CheckposLogo from "../../../../../assets/images/logo.png";
import { QuotaAlertSection } from "./styles";

export default function LaboratoryHeader({
	scrollDirection,
	userdata,
	campaignRegion,
	location,
	clientSlug,
	pharmaName,
	templateProducts,
	bookQty,
	qty,
	setShowDrawer,
	showDrawer,
	browserInfo,
	clientPhotoUrl,
	clientPlanData,
}) {
	const onCloseAlertError = () => {};

	return (
		<Layout.LayoutHeader
			justify="space-evenly"
			align="middle"
			scroll={scrollDirection}
		>
			<Col md={3} lg={3} xl={3}>
				<Link to="/">
					<Image src={clientPhotoUrl} alt="Logo Laboratorio" height={45} />
					{/* <Typo level={6} type="secondary" style={{ marginLeft: 5 }}>
						{clientSlug}
					</Typo> */}
				</Link>
			</Col>
			<Col md={7} lg={7} xl={7}>
				<Layout.LayoutHeaderOptions
					style={{
						gap: "30px",
					}}
				></Layout.LayoutHeaderOptions>
			</Col>

			<Col md={6} lg={6} xl={8}>
				<Image src={CheckposLogo} alt="Logo Checkpos Transfer" height={45} />
			</Col>

			<Col md={3} lg={3} xl={3}>
				{(userdata.p_shop || (!userdata.p_shop && userdata.p_mobile)) && (
					<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
						{userdata.p_shop && !userdata.p_mobile && (
							<Link to="/admin/laboratorySellerWeb">
								<Layout.HeaderAction
									style={{
										width: "60px",
										marginTop: "5px",
									}}
								>
									<Layout.HeaderIcon>
										<Badge
											count={templateProducts?.reduce(
												(acc, item) => acc + item.quantity,
												0,
											)}
											offset={[9, -6]}
											size="large"
											color={COLORS.Default}
										>
											<div
												style={{
													fontSize: "30px",
													position: "relative",
													top: "-2px",
												}}
											>
												<PhoneOutlined
													style={{
														color: COLORS.Primary,
													}}
												/>
											</div>
											<div
												style={{
													position: "absolute",
													fontSize: SIZES.level8,
													color: COLORS.Primary,
													top: "40px",
													left: "-3px",
												}}
											>
												Pedidos
											</div>
										</Badge>
									</Layout.HeaderIcon>
								</Layout.HeaderAction>
							</Link>
						)}
						{userdata.p_shop && userdata.p_mobile && (
							<Link to="/admin/expoSellerWeb">
								<Layout.HeaderAction
									style={{
										width: "60px",
										marginTop: "5px",
									}}
								>
									<Layout.HeaderIcon>
										<Badge
											count={templateProducts?.reduce(
												(acc, item) => acc + item.quantity,
												0,
											)}
											offset={[9, -6]}
											size="large"
											color={COLORS.Default}
										>
											<div
												style={{
													fontSize: "30px",
													position: "relative",
													top: "-2px",
												}}
											>
												<AuditOutlined
													style={{
														color: COLORS.Primary,
													}}
												/>
											</div>
											<div
												style={{
													position: "absolute",
													fontSize: SIZES.level8,
													color: COLORS.Primary,
													top: "40px",
													left: "2px",
												}}
											>
												Expo
											</div>
										</Badge>
									</Layout.HeaderIcon>
								</Layout.HeaderAction>
							</Link>
						)}
						{!userdata.p_shop && userdata.p_mobile && (
							<Link to="/homeMobile">
								<Layout.HeaderAction
									style={{
										width: "60px",
										marginTop: "5px",
									}}
								>
									<Layout.HeaderIcon>
										<Badge
											count={templateProducts?.reduce(
												(acc, item) => acc + item.quantity,
												0,
											)}
											offset={[9, -6]}
											size="large"
											color={COLORS.Default}
										>
											<div
												style={{
													fontSize: "30px",
													position: "relative",
													top: "-2px",
												}}
											>
												<PhoneOutlined
													style={{
														color: COLORS.Primary,
													}}
												/>
											</div>
											<div
												style={{
													position: "absolute",
													fontSize: SIZES.level8,
													color: COLORS.Primary,
													top: "40px",
													left: "-3px",
												}}
											>
												Pedidos
											</div>
										</Badge>
									</Layout.HeaderIcon>
								</Layout.HeaderAction>
							</Link>
						)}
						<Link to="/cart">
							<Layout.HeaderAction
								style={{
									width: "60px",
									marginLeft: "10px",
								}}
							>
								<Layout.HeaderIcon>
									<Badge
										count={qty}
										offset={[-14, -7]}
										size="large"
										color={COLORS.Default}
									>
										<Image
											src={CartIcon}
											alt="Cart"
											style={{
												width: "50%",
											}}
										/>
									</Badge>
								</Layout.HeaderIcon>
							</Layout.HeaderAction>
						</Link>
					</div>
				)}
			</Col>
			<Col md={2} lg={2} xl={2}>
				<Layout.HeaderAction
					onClick={() => setShowDrawer(!showDrawer)}
					style={{
						width: "100px",
					}}
				>
					<Layout.HeaderMenuIcon>
						<Layout.HeaderMenuIconContainer firefox={browserInfo.firefox}>
							<Image
								src={MenuIcon}
								alt="Menu"
								style={{
									height: "50%",
									width: "50%",
									marginLeft: "10px",
								}}
							/>
							<Layout.HeaderMenuParagraph>Menú</Layout.HeaderMenuParagraph>
						</Layout.HeaderMenuIconContainer>
					</Layout.HeaderMenuIcon>
				</Layout.HeaderAction>
			</Col>

			{clientPlanData &&
				clientPlanData.usagePercent > 60 &&
				clientPlanData.usagePercent < 80 &&
				!clientPlanData.shouldBlock && (
					<QuotaAlertSection>
						<Alert
							message={
								<Typo level={6} weight="bold">
									El consumo del Plan IA supera el 60%. Llegado al 100% se
									pausará el servicio.
								</Typo>
							}
							type="warning"
							closable
							onClose={onCloseAlertError}
						/>
					</QuotaAlertSection>
				)}

			{clientPlanData &&
				clientPlanData.usagePercent > 80 &&
				!clientPlanData.shouldBlock && (
					<QuotaAlertSection>
						<Alert
							message={
								<Typo level={6} weight="bold">
									El consumo del Plan IA supera el 80%. Llegado al 100% se
									pausará el servicio.
								</Typo>
							}
							type="error"
							closable
							onClose={onCloseAlertError}
						/>
					</QuotaAlertSection>
				)}

			{clientPlanData && clientPlanData.shouldBlock && (
				<QuotaAlertSection>
					<Alert
						message={
							<Typo level={6} weight="bold">
								Limite de Plan IA alcanzado. Agente fuera de servicio.
							</Typo>
						}
						type="error"
						closable
						onClose={onCloseAlertError}
					/>
				</QuotaAlertSection>
			)}
		</Layout.LayoutHeader>
	);
}
